import React, { Component } from 'react';
import Loading from '../shared/Loading';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import NewSignIn from '../NewSignIn';

const GET_LOCATION = gql`
  query getGeoLocation {
    ipLocationInformation {
      countryCode
      stateCode
      cityCode
    }
  }
`;

class GeoRouterSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { history } = this.props;
    return (
      <Query query={GET_LOCATION}>
        {({ loading, error, data, refetch }) => {
          console.log(data);

          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          if (data.ipLocationInformation) {
            return (
              <NewSignIn
                country={data.ipLocationInformation.countryCode}
                city={data.ipLocationInformation.cityCode}
              />
            );
          }
        }}
      </Query>
    );
  }
}

export default GeoRouterSignup;



// WEBPACK FOOTER //
// ./src/components/GeoRouter/signin.js